import { render, staticRenderFns } from "./ContestEntriesDialog.vue?vue&type=template&id=ba9e96ba"
import script from "./ContestEntriesDialog.vue?vue&type=script&lang=ts"
export * from "./ContestEntriesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports